import { isEmail } from 'validator';

import { validateForUI } from 'common/helpers/jsonValidator';

const feedbackSchema = {
  type: 'object',
  properties: {
    comments: { type: 'string' },
    isSuggestion: { type: 'boolean' },
    isQuestion: { type: 'boolean' },
    isLike: { type: 'boolean' },
    isDislike: { type: 'boolean' },
    feedbackEmail: { type: 'string' }
  },
  required: ['feedbackEmail', 'comments', 'commentType'],
  additionalProperties: false
};

export const validateSubmit = (form) => {
  const errors = validateForUI(feedbackSchema, form, customValidate(form));
  return errors;
};

const customValidate = (form) => {
  const errorArray = [];
  if (form.feedbackEmail && !isEmail(form.feedbackEmail)) {
    errorArray.push({
      field: 'feedbackEmail',
      message: 'Invalid Email'
    });
  }

  if (
    !form.isSuggestion &&
    !form.isQuestion &&
    !form.isLike &&
    !form.isDislike
  ) {
    errorArray.push({
      field: 'Suggestion',
      message: 'Select at least one option'
    });
  }

  return errorArray;
};
